exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-proj[data-v-131cfc9e]{background-color:rgba(77,192,181,.129)}", ""]);

// exports
